
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#000","d":"M17.548 12.01a1.99 1.99 0 113.979-.02 1.99 1.99 0 01-3.979.02zm-7.534 0a1.98 1.98 0 113.96-.001 1.98 1.98 0 01-3.96.001zm-7.543 0a1.992 1.992 0 111.981 1.981 1.98 1.98 0 01-1.98-1.981z"}})])])
          )
        }
      }
    